import React, { useState } from 'react';

import ProfileSetupForm, {
  StepKeys,
  DEFAULT_ACTIVE_STEP,
} from './ProfileSetupForm';
import imgLogo from 'assets/img/logo-new.svg';
import WelcomeSectionWrapper from '../WelcomeSectionWrapper';

import styles from './WelcomePage.module.less';

export default function WelcomePage() {
  const [completedStepsCount, setCompletedStepsCount] = useState<StepKeys>(
    DEFAULT_ACTIVE_STEP,
  );

  return (
    <div className={styles.contentWrapp}>
      <img className={styles.logo} src={imgLogo} alt="logo" />

      <WelcomeSectionWrapper completedStepsCount={completedStepsCount}>
        <ProfileSetupForm onStepChange={setCompletedStepsCount} />
      </WelcomeSectionWrapper>
    </div>
  );
}
